import { render, staticRenderFns } from "./escalated-alert-card-users-tab.vue?vue&type=template&id=38861d7f&"
import script from "./escalated-alert-card-users-tab.vue?vue&type=script&lang=ts&"
export * from "./escalated-alert-card-users-tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports